import React from "react"
import ReactTable from "react-table"
import { parse as parseDate, format } from "date-fns"
import { makeDefaultTableState, buildParams } from "../../helpers/table"
import { getRequest } from "../../helpers/api"

export default class ClientsTable extends React.Component {
  constructor(props) {
    super(props)

    this.state = makeDefaultTableState({})
  }

  componentDidMount() {
    setTimeout(this.fetchData, 100)
  }

  fetchData = async () => {
    this.setState({ isLoading: true })

    const params = buildParams(this.state)
    const resp = await getRequest("/api/companies", params)
    const json = await resp.json()
    const { data, meta } = json

    this.setState({ data, meta, isLoading: false })
  }

  render() {
    const { newPath, newText } = this.props
    const { data, meta, isLoading, searchQuery, page, pageSize, minRows, sorted, filtered, resized, expanded } = this.state
    return (
      <div>
        <div className="flex flex-column  flex-row-ns items-center-ns mb5">
          <h1 className="flex-auto page-title mb0">Solicitors</h1>
          <div className="flex self-stretch items-center justify-between bg-white search-field mv4 mv0-ns">
            <label htmlFor="client-keyword-search" className="flex items-center"><i className="material-icons">search</i></label>
            <input id="client-keyword-search" type="text" placeholder="Keywords" value={searchQuery} onChange={e => this.setState({ searchQuery: e.target.value }, this.fetchData)} />
          </div>
          <a href={newPath} className="button -with-icon -primary ml0 ml4-ns">
            <i className="material-icons">add_circle</i>
            {newText}
          </a>
        </div>
        <div className="content-box">
          <div className="inner">
            <ReactTable
              filterable={false}
              // onFetchData={this.fetchData}
              loading={isLoading}
              data={data}
              pages={meta.total_pages}
              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
              className="data-table"
              columns={[
                {
                  Header: "Name",
                  accessor: "name",
                  width: 200,
                },
                {
                  Header: "Ref prefix",
                  accessor: "ref_prefix"
                },
                {
                  Header: "Date added",
                  accessor: "created_at",
                  width: 180,
                  Cell: props => {
                    if (props.value) {
                      const date = parseDate(props.value)
                      return <span>{format(date, "Do MMMM YY")}</span>
                    }
                    return null
                  }
                }
              ]}

              // Controlled State Overrides (see Fully Controlled Component section)
              page={page}
              pageSize={pageSize}
              minRows={minRows}
              sorted={sorted}
              filtered={filtered}
              resized={resized}
              expanded={expanded}

              // Controlled State Callbacks
              onSortedChange={sorted => this.setState({ sorted }, this.fetchData)}
              onPageChange={page => this.setState({ page }, this.fetchData)}
              onPageSizeChange={(pageSize, page) =>
                this.setState({ page, pageSize }, this.fetchData)}
              onExpandedChange={expanded => this.setState({ expanded }, this.fetchData)}
              onResizedChange={resized => this.setState({ resized })}
              onFilteredChange={filtered => this.setState({ filtered }, this.fetchData)}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    console.log("A Td Element was clicked!");
                    console.log("it produced this event:", e);
                    console.log("It was in this column:", column);
                    console.log("It was in this row:", rowInfo);
                    console.log("It was in this table instance:", instance);

                    // IMPORTANT! React-Table uses onClick internally to trigger
                    // events like expanding SubComponents and pivots.
                    // By default a custom 'onClick' handler will override this functionality.
                    // If you want to fire the original onClick handler, call the
                    // 'handleOriginal' function.
                    // if (handleOriginal) {
                    //   return handleOriginal();
                    // }

                    if (rowInfo) {
                      Turbolinks.visit(`/admin/solicitors/${rowInfo.original.id}`)
                    }
                  }
                };
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}
